export const baseUrl = 'http://123.57.200.240:8058/soa-web'
// export const baseUrl = 'http://192.168.1.57:8058/soa-web'//测试三（yong）
//export const baseUrl = 'http://123.56.207.13:8058/soa-web'
//export const baseUrl = 'http://192.168.1.18:8058/soa-web' // 测试地址
// export const baseUrl = 'http://192.168.1.23:8058/soa-web' // 测试地址（已废弃）
export const ERR_OK = 200
export const pageSize = 20
export const pageSizes = [20, 40, 60, 80, 100]
// 联盟
export const one = './static/images/logoTwo.png'
export const head = './static/images/headTwo.png'



// WEBPACK FOOTER //
// ./src/common/api/api.js